import { render } from "./RappresentantiDetail.vue?vue&type=template&id=f23c16e0&scoped=true"
import script from "./RappresentantiDetail.vue?vue&type=script&lang=js"
export * from "./RappresentantiDetail.vue?vue&type=script&lang=js"

import "./RappresentantiDetail.vue?vue&type=style&index=0&id=f23c16e0&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f23c16e0"]])

export default __exports__